<template>
    <!-- Modale -->

    <div

        class="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
    >
        <div class="bg-white rounded-sm shadow-lg w-md">
            <div class="p-6 border-b border-gray-200">
                <h2 class="text-lg font-semibold">Nouvelle consultation</h2>
            </div>
            <form @submit.prevent="submitForm" class="p-6">
                <div class="">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Date de consultation</label>
                    <input is="date-picker" v-model="form.consultation_date"
                           name="consultation_date" type="date" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2A4493] focus:border-transparent"
                           required>
                </div>
                <div class="">
                    <label class="block text-sm font-medium text-gray-700 mb-2">Durée(en minutes)</label>
                    <input  v-model="form.estimated_duration_minutes"
                           name="estimated_duration_minutes" type="number" min="1" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2A4493] focus:border-transparent"
                           required>
                </div>
                <div class="">
                    <label for="address" class="block text-sm font-medium text-gray-700 mb-2">Adresse</label>
                    <textarea
                        id="address"
                        v-model="form.adresse"
                        rows="3"
                        required
                        class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#2A4493] focus:border-transparent"
                    ></textarea>
                </div>

                <!-- Boutons -->
                <div class="flex justify-end space-x-3 mt-8 pt-6 border-t border-gray-200">
                    <button
                        type="button"
                        @click="closeModal"
                        class="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 focus:outline-none"
                    >
                        Annuler
                    </button>
                    <button
                        type="submit"
                        class="px-6 py-2 bg-[#2A4493] text-white rounded-md hover:bg-[#1e3070] focus:outline-none"
                    >
                        Enregistrer
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script setup>
import {ref, watch} from "vue";
import axios from "axios";
import {NotificationToast} from "@/utils/notification.js";
import XInput from "@/vue/Form/X-Input.vue";

const props=defineProps({
    bookId:Number
})
const emit=defineEmits(['closeModal'])
const form = ref({
    adresse: "",
    estimated_duration_minutes: "",
    consultation_date: "",
});

const errors = ref({});

const closeModal=()=> {
    emit('closeModal')
}
const csrfToken = document.querySelector('meta[name="ena__verify"]');
const submitForm=async()=> {
    try {
        errors.value = {};const response = await axios({
            method: 'post',
            url: `/consultation/store/${props.bookId}`,
            data: form.value,
            headers: {
                'X-CSRF-TOKEN': csrfToken.getAttribute('content')
            }
        });
        NotificationToast(response.data.type,response.data.message)
        closeModal();
    } catch (e) {
        if (e) {
            console.log(e);
        }
    }
}
</script>
